export type Destination = {
  pageId: string;
  relativeUrl?: string;
};

export type NavigationOptions = {
  displayMode?: 'auto' | 'main' | 'overlay';
  history?: 'push' | 'replace';
};

/**
 * @deprecated
 */
type NavigateToPageId = string;

export type Navigate = (
  navigateTo: NavigateToPageId | Destination,
  options?: NavigationOptions,
) => void;

export type GetPageUrl = (urlTo: Destination) => Promise<string>;

export type NavigateBack = () => void;
